// MAster submodule id selection start from 51 in UserMAster
// Commercial submodule id selection start from 111 in UserMAster
export const moduleList = [
  {
    id: 1,
    name: "Dashboard",
  },
  {
    id: 2,
    name: "Master",
  },
  // Master children from 51 to 62
  {
    id: 51,
    name: "Master EQP",
  },
  {
    id: 52,
    name: "Instrument",
  },
  {
    id: 53,
    name: "Duc Master",
  },
  {
    id: 54,
    name: "Discipline",
  },
  {
    id: 55,
    name: "Remark",
  },
  {
    id: 57,
    name: "Client",
  },
  {
    id: 58,
    name: "Units",
  },
  {
    id: 59,
    name: "Table Template",
  },
  {
    id: 60,
    name: "Datasheet Template",
  },
  {
    id: 61,
    name: "Uncertainty",
  },
  {
    id: 62,
    name: "Settings",
  },
  {
    id: 63,
    name: "Assigned Duc",
  },
  {
    id: 64,
    name: "Reserved SRF",
  },
  {
    id: 65,
    name: "Thread Ring/Plug",
  },
  {
    id: 66,
    name: "Tapper Thread Ring",
  },
  {
    id: 3,
    name: "Inward",
  },
  {
    id: 4,
    name: "Datasheets",
  },
  {
    id: 5,
    name: "Certificates",
  },
  {
    id: 9,
    name: "Inward Pending Items",
  },
  {
    id: 6,
    name: "Independent SRF",
  },
  {
    id: 7,
    name: "Courier Register",
  },
  {
    id: 8,
    name: "Expenses",
  },
  {
    id: 12,
    name: "Scheduler",
  },
  {
    id: 13,
    name: "External Calibration",
  },
  {
    id: 35,
    name: "Reports",
  },
  {
    id: 151,
    name: "Summary Reports",
  },
  {
    id: 152,
    name: "History Reports",
  },
  {
    id: 153,
    name: "Work Reports",
  },
  {
    id: 154,
    name: "WCR Report",
  },
  {
    id: 155,
    name: "Department Analytics",
  },  
  {
    id: 156,
    name: "Inward Register",
  },
  {
    id: 157,
    name: "Progress Report",
  },
  {
    id: 158,
    name: "SRF_ULR_Register",
  },
  {
    id: 159,
    name: "Master Uses",
  },
  {
    id: 160,
    name: "Approval Status",
  },
  {
    id: 161,
    name: "ReCalibration Report",
  },
  {
    id: 14,
    name: "Commercial",
  },
   // Commercial children from 111 to 117
  {
    id: 111,
    name: "Enquiry",
  },
  {
    id: 112,
    name: "Enquiry Followup",
  },
  {
    id: 113,
    name: "Price List",
  },
  {
    id: 114,
    name: "Quotation",
  },
  {
    id: 115,
    name: "poAcceptance",
  },
  {
    id: 116,
    name: "Invoice",
  },
  {
    id: 117,
    name: "Supplier Invoice",
  },
  {
    id: 17,
    name: "Payment",
  },
   // Paymnet children from 161 to 163
  {
    id: 1161,
    name: "Payment History",
  },
  {
    id: 1162,
    name: "Account Statement",
  },
  {
    id: 1163,
    name: "GST Report",
  },
  {
    id: 21,
    name: "Master In/Out",
  },
   // Master children from 171 to 172
  {
    id: 171,
    name: "Master Assign",
  },
  {
    id: 172,
    name: "Assign Report",
  },
  {
    id: 173,
    name: "Gate Pass",
  },
  {
    id: 36,
    name: "Independent Due",
  },
  {
    id: 37,
    name: "Task Management",
  },
  {
    id: 25,
    name: "User",
  },
  {
    id: 27,
    name: "Audit",
  },
  {
    id: 28,
    name: "Client Complaints",
  },
  {
    id: 29,
    name: "Client Feedback",
  },
  {
    id: 30,
    name: "Request Form",
  },
  {
    id: 31,
    name: "Documents",
  },
  {
    id: 32,
    name: "Help",
  },
  {
    id: 33,
    name: "Attendance",
  },
  {
    id: 34,
    name: "MarkAttendance",
  }, 
];

export const moduleHierarchy = {
  2: { min: 51, max: 66 },   // Master
  14: { min: 111, max: 117 }, // Commercial
  35: { min: 151, max: 161 }, // Reports
  17: { min: 1161, max: 1163 }, // payments
  21: { min: 171, max: 173 }, // master in/out
};

export const userDesignation = [
  {
    id: 1,
    name: "Calibration Engineer",
  },
  {
    id: 2,
    name: "Senior Engineer",
  },
  {
    id: 3,
    name: "Senior Calibration Engineer",
  },
  {
    id: 4,
    name: "Quality Manager",
  },
  {
    id: 5,
    name: "Technical Manager",
  },
  {
    id: 6,
    name: "Technical Head",
  },
  {
    id: 7,
    name: "Lab Head",
  },
  {
    id: 8,
    name: "Asst. Technical Manager",
  },
  {
    id: 9,
    name: "Chief Executive Director",
  },
  {
    id: 10,
    name: "Junior Accountant",
  },
  {
    id: 11,
    name: "Senior Accountant",
  },
  {
    id: 12,
    name: "Account Head",
  },
  {
    id: 13,
    name: "Lab Incharge",
  },
  {
    id: 14,
    name: "Executive Director-Technical",
  },
  {
    id: 15,
    name: "Testing Engineer",
  },
  {
    id: 16,
    name: "Senior Testing Engineer",
  },
  {
    id: 17,
    name: "Lab Assistance",
  },
  {
    id: 18,
    name: "Technical Assistant ",
  },
  {
    id: 19,
    name: "CEO",
  },
  {
    id: 20,
    name: "Director",
  },
  {
    id: 21,
    name: "Chief Executive Officer",
  },
  {
    id: 22,
    name: "Technical Director",
  },
  {
    id: 23,
    name: "Dy.Technical Manager",
  },
  {
    id: 24,
    name: "Managing Director",
  },
  {
    id: 25,
    name: "Sr. Manager Calibration",
  },
  {
    id: 26,
    name: "Lab Manager",
  },
  {
    id: 27,
    name: "Lab Manager",
  },
  {
    id: 28,
    name: "Sales Representative",
  },
  {
    id: 29,
    name: "Sales Manager",
  },
  {
    id: 30,
    name: "Regional Sales Manager",
  },
  {
    id: 31,
    name: "Sales Assistant",
  },
  {
    id: 32,
    name: "Sales Executive",
  },
  {
    id: 33,
    name: "CMD",
  },
  {
    id: 34,
    name: "Director/QM",
  },
  {
    id: 35,
    name: "Managing Director/Quality Manager",
  },
  {
    id: 36,
    name: "MQ/TM",
  }
];

export const userTypes = [
  {
    id: 1,
    label: "Admin",
  },
  {
    id: 4,
    label: "Branch Admin",
  },
  {
    id: 2,
    label: "Engineer",
  },
  {
    id: 3,
    label: "Client",
  },
  {
    id: 5,
    label: "Lab Co-Ordinator",
  },
  {
    id: 6,
    label: "Account Dept",
  },
  {
    id: 7,
    label: "Sales Dept",
  },
  {
    id: 8,
    label: "Site InCharge",
  },
];

export const rolesArray = [
  {
    name: "Calibration Authority ",
    id: "1",
  },
  {
    name: "Approved Authority",
    id: "2",
  },
  ,
  {
    name: "Reviewed By",
    id: "3",
  },
  ,
  {
    name: "Signed By",
    id: "4",
  },
  ,
  {
    name: "Witnessed By",
    id: "5",
  },
];

export const headers = [
  { name: "Client" },
  { name: "Address" },
  { name: "Start Date" },
  { name: "End Date" },
];

export const editAccessOptions = [
  {
    id: 0,
    label: "All Access",
  },
  {
    id: 1,
    label: "Edit View",
  },
  {
    id: 2,
    label: "Delete",
  },
  {
    id: 3,
    label: "PDF Download",
  },
  {
    id: 4,
    label: "Excel Download",
  },
  {
    id: 5,
    label: "Copy Data",
  },
  {
    id: 6,
    label: "None",
  },
  {
    id: 7,
    label: "Failed Certificate Approval",
  },  
  {
    id: 8,
    label: "Backdate Show",
  },
  {
    id: 9,
    label: "Create SRF / Master EQP",
  },
  {
    id: 10,
    label: "Update SRF / Master EQP",
  },
  {
    id: 11,
    label: "View/Update Client Contact Details",
  },
]


export const userStatusOption = [
  {
    id: 1,
    label: "Active",
  },
  {
    id: 2,
    label: "InActive",
  },
];